export default {
  "Curiosity": {
    positiveIndicators: [
      "Questions why matters are as they are.",
      "Actively seeks out novel and extraordinary situations and experiences.",
      "Finds something that deeply interests them in whatever they are doing.",
      "Usually seeks to get a better understanding of people's thoughts, ideas or solutions.",
      "Asks good questions to find out the limits of their understanding.",
    ],
    negativeIndicators: [
      "Takes matters at face-value.",
      "Avoids new or out of the ordinary situations and experiences.",
      "Rarely finds something to interest them in whatever they are doing.",
      "Rarely seeks to better understand people's thoughts, ideas or solutions.",
      "Does not question the limits of their knowledge and understanding.",
    ],
  },
  "Open-minded": {
    positiveIndicators: [
      "Weighs up both sides of the argument before taking a stance.",
      "Prepared to let understanding and solutions emerge in discussions.",
      "Actively seeks out confirming or disconfirming evidence for existing beliefs.",
      "Thoroughly explores opinions and experiences of others before taking a stance.",
      "Adjusts existing beliefs in response to new and compelling evidence.",
    ],
    negativeIndicators: [
      "Is guided mainly by own opinions when making decisions.",
      "Closes debate down too quickly.",
      "Makes little attempt to seek out evidence to confirm or disconfirm beliefs.",
      "Often overlooks the opinions and experiences of others before taking a stance.",
      "Holds onto their position despite new and compelling evidence.",
    ],
  },
  "Originality": {
    positiveIndicators: [
      "Challenges core assumptions and rigid thinking.",
      "Brings together disparate information and ideas to create something new and useful.",
      "Reframes problems in ways that lead to progress.",
      "Makes creative use of opposites and contradiction.",
      "Draws useful connections between apparently unconnected facts.",
      "Creates the conditions for others to demonstrate fresh thinking.",
    ],
    negativeIndicators: [
      "Accepts, or does not see, unhelpful assumptions or rigid thinking.",
      "Views situations from a narrow perspective.",
      "Accepts existing definitions of problems, opportunities and solutions.",
      "Makes little use of opposites and contradictions.",
      "Struggles to see connections.",
      "Doesn't create the conditions for others to demonstrate fresh thinking.",
    ],
  },
  "Self-belief": {
    positiveIndicators: [
      "Appears to be consistently self-assured, even in unfamiliar situations.",
      "Has positive, ambitious, but realistic expectations about what they can achieve.",
      "Trusts their instinct and judgement.",
      "States ideas and opinions with clarity, authority and confidence.",
      "Sets own targets higher than expectations and believes they will achieve them.",
    ],
    negativeIndicators: [
      "Can appear to be lacking in confidence, particularly in unfamiliar situations.",
      "Underestimates what they are capable of achieving.",
      "Dimsisses their instinct and judgement.",
      "Is often anxious or apologetic about their contributions.",
      "Sets own targets lower than expectations and doubts that they can achieve them.",
    ],
  },
  "Bravery": {
    positiveIndicators: [
      "Pushes themselves outside of their comfort zone.",
      "Is prepared to disagree with the consensus view of a group.",
      "Prepared to say the obvious despite the risk of looking foolish.",
      "Speaks up for what they believe despite the potential of losing credibility.",
      "Prepared to challenge those in authority.",
    ],
    negativeIndicators: [
      "Actively avoids situations that will take them outside of their comfort zone.",
      "Is unlikely to disagree with the consensus view of a group.",
      "Keeps quiet for fear of looking foolish.",
      "Goes along with the majority or dominant view.",
      "Is unlikely to challenge those in authority.",
    ],
  },
  "Risk-taking": {
    positiveIndicators: [
      "Willing to embrace new changes even if disruptive.",
      "Identifies risks but puts them in perspective.",
      "Sees the risks of not-acting as well as the risks of acting.",
      "Moves quickly to action once choices have become clear.",
      "Makes bold or controversial moves to deliver the most desirable goals.",
    ],
    negativeIndicators: [
      "Prefers to protect the status quo.",
      "Gets nervous when others urge them to take risks.",
      "Exaggerates the level of risk.",
      "Focuses on the risks of acting and benefits or not-acting.",
      "Procrastinates, waits too long to make decisions.",
      "Takes the 'safe option' to deliver safe goals.",
    ],
  },
  "Zest": {
    positiveIndicators: [
      "Smiles a lot.",
      "Consistently appears fully awake and alert.",
      "Demonstrates consistently high levels of energy.",
      "Shows genuine enthusiasm about many things and activities.",
      "Energises other people around them.",
      "Is generally vibrant and eager to embrace the next challenge.",
    ],
    negativeIndicators: [
      "Has a serious demeanour.",
      "Is variable in their levels of alertness.",
      "Has variable levels of energy.",
      "Shows a lack of enthusiasm about many things or activities.",
      "Draws energy from others to help sustain their own energy.",
      "Frequently complains of feeling over-worked.",
    ],
  },
  "Optimism": {
    positiveIndicators: [
      "Looks at future possibilities with enthusiasm and excitement.",
      "Pays attention to what is good about a difficult situation.",
      "Focuses on the likelihood of successful goals.",
      "Doesn't get stuck on past failures - sees them as opportunities to learn valuable lessons.",
      "Believes in others' talents.",
      "Sees humanity as inherently positive.",
    ],
    negativeIndicators: [
      "Looks at future possibilities pessimistically.",
      "Misses what is good about a difficult situation.",
      "Identifies ways in which things may go wrong.",
      "Dwells upon past failures at length.",
      "Sceptical about the talents of others.",
      "Can be cynical about the nature of humanity.",
    ],
  },
  "Appetite": {
    positiveIndicators: [
      "Believes they can make a significant difference.",
      "Challenges the status quo in areas they feel strongly about.",
      "Is excited about shaping the future.",
      "Seeks out daily small ways to make a difference.",
      "Open to what they need to change personally in order to effect wider change.",
    ],
    negativeIndicators: [
      "Doubts their contribution.",
      "Resigns themselves to situations.",
      "Is cautious about what is possible for the future.",
      "Is sceptical about the significance of their actions and contribution.",
      "Can be reluctant to embrace personal change and growth.",
    ],
  },
  "Resilience": {
    positiveIndicators: [
      "Handles setbacks in a balanced and objective way.",
      "Actively incorporates learning from setbacks into a revised approach.",
      "Remains positive and engaged even in the face of adversity.",
      "Chooses actively what they think and feel about the world.",
      "Willing to acknowledge their own part in setbacks.",
      "Recovers their self-confidence quickly.",
    ],
    negativeIndicators: [
      "Takes setbacks as a personal failure or criticism.",
      "Misses learning opportunity in setbacks.",
      "Sees setbacks as evidence that their goals are not achievable.",
      "Feels at the mercy of their external situations.",
      "Reluctant to examine their part.",
      "Takes time to build back up their self-confidence or may quit and direct energies elsewhere.",
    ],
  },
  "Perseverance": {
    positiveIndicators: [
      "Focuses fully on tasks for long periods or until completed.",
      "Identifies which situations are worth persisting with and which to quit.",
      "Persists with goals in spite of obstacles or difficulties.",
      "Remains confident that they will achieve a positive goal if they persist.",
      "Prepares themselves with what they need in order to achieve success.",
    ],
    negativeIndicators: [
      "Loses focus, switches frequently between activities.",
      "Commits quickly but gives up quickly.",
      "Gives up easily when faced with difficulties.",
      "Loses confidence if persistence is required.",
      "Doesn't prepare themselves before committing.",
    ],
  },
  "Grip": {
    positiveIndicators: [
      "Takes rapid action in moving the goal from plans into progress.",
      "Directs and enables the efforts of others to achieve a goal.",
      "Tracks progress towards the goal and rapidly adjusts course if necessary.",
      "Is able to be assertive with others about the importance of their personal priorities.",
    ],
    negativeIndicators: [
      "Prioritises planning and preparation over rapid progress.",
      "Allows too much leeway for others in deciding what they want to contribute.",
      "Is slow to adjust course.",
      "Accepts too easily when their personal focus is pushed down the priorities list by others.",
    ],
  },
  "Consistency": {
    positiveIndicators: [
      "Acts consistently across situations with regards to their personal values.",
      "Keeps to their promises and commitments; their word is their bond.",
      "Is discreet, respects confidence and confidentiality.",
      "Regarded by others as genuine.",
      "Acknowledges what they are feeling to themselves and others.",
      "Readily admits their mistakes.",
    ],
    negativeIndicators: [
      "Acts inconsistently, confuses people about their personal values.",
      "May fail to keep their promises and commitments.",
      "Is indiscreet, may break confidences.",
      "May be seen by others as difficult to read or even misleading.",
      "Rarely portrays how they really feel.",
      "Blames others or the situation for their mistakes.",
    ],
  },
  "Fairness": {
    positiveIndicators: [
      "Treats everyone with equivalent respect.",
      "Challenges unfairness.",
      "Is even-handed.",
      "Ensures everyone has opportunities.",
      "Balances their own needs and the needs of others.",
      "Makes others feel safe with respect to their intentions towards them.",
      "Rewards people based on the value of their contribution.",
    ],
    negativeIndicators: [
      "Treats some people more respectfully than others.",
      "Views unfairness as a fact of life.",
      "Has favourites.",
      "Is not concerned with how fairly opportunities are distributed.",
      "Puts their own needs before the needs of others.",
      "Leaves others feeling threatened or unsure about their intentions towards them.",
      "Is not objective in the way they reward people.",
    ],
  },
  "Ownership": {
    positiveIndicators: [
      "Embraces all their duties, even when they don't enjoy them.",
      "Holds themselves accountable for the goals of their actions.",
      "Is seen as highly dependable.",
      "Takes responsibility for the mistakes of others whom them manage or oversee.",
      "Takes on tasks others avoid out of a sense of duty towards the team or wider organisation.",
    ],
    negativeIndicators: [
      "Negotiates on, or avoids, the duties they do not like.",
      "Distances themselves from the goals of their actions.",
      "Is not seen by others as highly dependable.",
      "Takes responsibility only for their own mistakes.",
      "Avoids taking on tasks that no-one else wants to do.",
    ],
  },
  "Humility": {
    positiveIndicators: [
      "Values their strengths and acknowledges their weaknesses.",
      "Knows their limitations - what they can and cannot deliver on.",
      "Is sought out by others as a reliable giver of feedback.",
      "Does not pretend to have knowledge or to understand when they don't.",
      "Is easy to teach or coach.",
      "Is willing to ask naïve questions.",
    ],
    negativeIndicators: [
      "Lacks awareness of their strengths and weaknesses.",
      "Under-estimates or over-estimates their limitations.",
      "Is rarely sought out by others for feedback.",
      "Pretends to have knowledge or to understand an issue when they don't.",
      "Is difficult to teach or coach.",
      "Either brags or diminishes their significance entirely.",
    ],
  },
  "Self-regulation": {
    positiveIndicators: [
      "Seen as highly disciplined and self-motivated.",
      "Resists acting on their impulses.",
      "Considers what they want to say prior to saying it and rarely regrets what they say.",
      "Is emotionally 'even-keeled' - neither great highs nor deep lows of emotion.",
      "Quickly breaks bad patterns before they become habits.",
      "Actively monitors own internal feelings and desires.",
    ],
    negativeIndicators: [
      "Not seen to be highly disciplined and self-motivated.",
      "Acts on their impulses without caring about the consequences.",
      "Has a more impulsive style of communication.",
      "Is emotionally more variable, switching rapidly from one emotion to another.",
      "Bad habits last a long time.",
      "Rarely monitors own internal feelings and desires.",
    ],
  },
  "Prudence": {
    positiveIndicators: [
      "Balances short-term with long-term.",
      "Considers options carefully, even when things seem obvious.",
      "Anticipates the consequences of their actions and decisions.",
      "Makes contingency plans.",
      "Considered to be wise.",
      "Has good judgement about what is courageous and what is reckless.",
      "Has a measured way of speaking.",
    ],
    negativeIndicators: [
      "Focuses mostly on short-term wins.",
      "May rush into the obvious choice, without really considering other options.",
      "Doesn't anticipate the consequences of their actions and decisions.",
      "Rarely makes contingency plans.",
      "Considered to be impulsive.",
      "Can mistake thrill-seeking for courage.",
    ],
  },
  "Quick mind": {
    positiveIndicators: [
      "Is quick to understand complex information.",
      "Gets to the core of problems.",
      "Can handle lots of different pieces of information at the same time.",
      "Asks insightful questions that few others do.",
      "Makes meaningful links between apparently unconnected facts.",
      "Quickly notices contradictions and spots faulty reasoning.",
      "Anticipates the goals of complex discussions before others.",
    ],
    negativeIndicators: [
      "Is slower to understand complex information.",
      "Is unclear what is core to a problem and what is a symptom.",
      "Prefers to process one piece of information at a time.",
      "Asks few questions or asks questions of a basic nature.",
      "Takes data at face value.",
      "Does not notice contradictions or faulty reasoning.",
      "Follows rather than leads complex discussions.",
    ],
  },
  "Simplifies": {
    positiveIndicators: [
      "Simplifies issues whilst retaining awareness of complexities.",
      "Effective in helping others understand complex issues.",
      "Gives concise answers to tough questions.",
      "Good at summarising a discussion or debate.",
      "Able to handle the abstract as well as concrete and practical.",
      "Sees the bigger picture and is good at communicating it.",
    ],
    negativeIndicators: [
      "Fails to simplify.",
      "Can struggle to help others understand complex issues.",
      "Gives wordy answers to tough questions.",
      "Finds it difficult to summarise - tends to list points rather than summarise.",
      "Finds it difficult to move beyond the immediate concrete details of an issue.",
      "Gets immersed in the detail.",
    ],
  },
  "Thinks ahead": {
    positiveIndicators: [
      "Thinks ahead, linking current decisions and actions to future objectives.",
      "Effective at thinking into the future in order to inform today's thinking.",
      "Is rarely surprised at the way events or projects turn out.",
      "Distinguishes between decisions that can and cannot be reversed at a later point.",
      "Can get frustrated at the short-term nature of other's thinking.",
    ],
    negativeIndicators: [
      "Doesn't easily link consequences to each other.",
      "Tends not to think into the future in order to inform today's thinking.",
      "Is surprised at the way events or projects turn out.",
      "Doesn't distinguish between decisions that can and cannot be reversed at a later point.",
      "Is content with the short-term nature of other's thinking.",
    ],
  },
  "Judgement": {
    positiveIndicators: [
      "Is good at seeing problems from many angles.",
      "Is valued by others for their good judgement and ability to analyse problems.",
      "Has a range of approaches for solving problems.",
      "Actively encourages devil's advocates and attempts to pull solutions apart.",
      "Can spot faulty reasoning and wrong conclusions in a group discussion.",
    ],
    negativeIndicators: [
      "Sees problems from their own point of view.",
      "Gets immersed in the detail and technicalities of problems.",
      "Acts as if one approach fits all problems.",
      "May become defensive or protective of own ideas if challenged.",
      "Is slow to spot faulty reasoning or wrong conclusions in a group discussion.",
    ],
  },
  "Sees opportunities": {
    positiveIndicators: [
      "Spots opportunities that others miss to create value, whether financial or social value.",
      "Monitors the external environment for emerging trends and opportunities.",
      "Is open-minded about different routes to value (e.g. technology, partnering, product innovation, social enterprise).",
      "Identifies the practical steps needed to capture the opportunity.",
      "Is seen as entrepreneurial.",
    ],
    negativeIndicators: [
      "Doesn't focus in on value creation.",
      "Is narrow in their understanding and approach to value.",
      "Doesn't tune into, or misreads, emerging trends.",
      "Spots value after others have captured it.",
      "Sees opportunities, but not what needs doing practically.",
      "Is seen as managerial rather than entrepreneurial.",
    ],
  },
  "Creates solutions": {
    positiveIndicators: [
      "Understands what will work in any given situation.",
      "Good at translating ideas into practical activities.",
      "Can usually find a workable solution to problems.",
      "Is happy to go for simple solutions if they work.",
      "Balances the needs of the present with the demands of the future.",
      "Sustains focus until intended benefits are delivered.",
    ],
    negativeIndicators: [
      "Is unrealistic about what will work.",
      "Focuses on coming up with ideas rather than how to implement them.",
      "Solutions are unworkable or do not solve the issue.",
      "Wastes time innovating when simple, practical solutions are available.",
      "Either too focused on future demands or on current needs.",
      "Loses interest once a solution is implemented.",
    ],
  },
  "Achievable": {
    positiveIndicators: [
      "Is seen as grounded in reality.",
      "Known as a 'safe pair of hands' when it comes to delivering pieces of work.",
      "Has a realistic view of what can be achieved within a timeframe.",
      "Is good at sequencing activities to deliver goals.",
      "Good at knowing what resources will be required to deliver.",
    ],
    negativeIndicators: [
      "Seen as too optimistic, or too pessimistic, rather than grounded in reality",
      "Unpredictable, rather than safe pair of hands.",
      "Either too pessimistic about what can be achieved or too optimistic.",
      "Struggles to identify the most practical sequence of activities.",
      "Unrealistic in their judgements about what resources are required.",
    ],
  },
  "Optimises": {
    positiveIndicators: [
      "Gets things done quickly and efficiently.",
      "Is happy to pursue small gains, stripping away unnecessary features or inefficiencies.",
      "Feels no need to reinvent the wheel.",
      "Produces solutions that are easily understood and implemented.",
      "Is guided by common sense and previous experience.",
      "Seeks out and uses feedback to fine-tune development.",
    ],
    negativeIndicators: [
      "Over-engineers or under-engineers solutions.",
      "Only pursues step changes.",
      "Always drawn to the latest innovation.",
      "Makes implementation more complex than it needs to be.",
      "Pursues elegant solutions more than pragmatic ones.",
      "Does not seek out user feedback.",
    ],
  },
  "Perspective": {
    positiveIndicators: [
      "Sought out to give their opinion on what changes may happen.",
      "Listens to and understands the perspective of people resistant to their ideas.",
      "Sees constraints or fixed views as discussable and potentially transformable.",
      "Seeks solutions that meet their own needs and the wider groups.",
      "Understands the emotional challenges of bringing a project to life.",
    ],
    negativeIndicators: [
      "Rarely sought out to give their opinion on what changes may happen.",
      "Doesn't seek out advice or views from others.",
      "Sees constraints or push back as signs to give up.",
      "Sticks with own position and blames others for not understanding.",
      "Focuses on technicalities of bringing a project to life, and not the impact on people.",
    ],
  },
  "Insightful": {
    positiveIndicators: [
      "Tunes into underlying emotions and behaviours.",
      "Pays attention to what people are not saying as well as what they are saying.",
      "Notices subtle cues that indicate something is not as it seems.",
      "Thinks about underlying motivations and personal agendas.",
      "Identifies the vested interests of all key stakeholders.",
      "Understands both formal and informal agendas.",
    ],
    negativeIndicators: [
      "Only uses concrete information to inform their understanding.",
      "Doesn't hear what is not said.",
      "Misses subtle cues that indicate all is not as it seems.",
      "Denies personal agendas; considers only the explicit and stated objectives of others.",
      "Assumes that what is said is all that's meant.",
      "Considers only the formal agendas.",
    ],
  },
  "Connects": {
    positiveIndicators: [
      "Identifies the full range of stakeholders and influencers for all projects.",
      "Considers everyone who is influential and the relationships they need to build.",
      "Checks-in frequently with their network.",
      "Is well hooked into informal networks.",
      "Pays attention to the network of people's relationships.",
      "Handles formal and informal channels of authority in a diplomatic manner.",
    ],
    negativeIndicators: [
      "Spends little time thinking through who the stakeholders and influencers are.",
      "Allows relationships to be established piecemeal with no strategic intent.",
      "Doesn't spot dissatisfaction until it has progressed.",
      "Misses out on informal channels of communication.",
      "Doesn't pay attention to who is connected to whom.",
      "Looks only to the formal positions of authority.",
    ],
  },
  "Influential": {
    positiveIndicators: [
      "Uses a range of approaches to influence others.",
      "Is clear about the goals they want when influencing.",
      "Tailors compelling arguments for their audience.",
      "Seems to know the right thing to say at the right moment.",
      "Understands that resistance often arises from differences in interpretation. ",
      "Is comfortable looking at the interplay of personal agendas, and other factors.",
    ],
    negativeIndicators: [
      "Uses the same approach with everyone.",
      "Is vague about what goals they want.",
      "Presents arguments without thinking about the audience, or the timing of their approach.",
      "Sees difference as hard to overcome, or caused by lack of clear rules. Gives up easily.",
      "Focuses on the task, without paying attention to personal agendas or other goals.",
    ],
  },
  "Self-awareness": {
    positiveIndicators: [
      "Aware of their feelings and thoughts.",
      "Understands the impact they have on others.",
      "Understands what triggers patterns of feelings and behaviour.",
      "Knows what is important to them and why.",
      "Uses their awareness of their emotions as part of their thinking about someone or a situation.",
      "Able to see their own part in difficult situations.",
    ],
    negativeIndicators: [
      "Not able to say what they are feeling, or denies feeling anything.",
      "Has blind spots about their impact on others.",
      "Unaware of what triggers their feelings and behaviour.",
      "Limited understanding of why things are important to them.",
      "Regards feelings and thoughts as separate things that do not affect each other.",
      "Denies or fails to see their own part in difficult situations.",
    ],
  },
  "Other awareness": {
    positiveIndicators: [
      "Tunes into others' feelings.",
      "Checks out their perceptions by asking the other person.",
      "Shows empathy.",
      "Unconsciously matches other person (physical stance and emotional tone).",
      "Is insightful about how emotions and experiences link to behaviour.",
      "Interested in others' views of the world, is genuinely curious about them.",
      "Readily puts themselves in another person's shoes.",
    ],
    negativeIndicators: [
      "Assumes others feel or think the same way as they do.",
      "Indifferent to others' feelings or experiences.",
      "Lacks empathy.",
      "Doesn't notice physical gestures, stance and voice.",
      "Unable to explain people's behaviour in terms of their emotions.",
      "Has little interest in the other's world; relates everything back to themselves.",
      "Responds at face value to other's behaviour.",
    ],
  },
  "Manages expectations": {
    positiveIndicators: [
      "Asks others what they expect and need of them.",
      "Agrees clear objectives and deliverables.",
      "Ensures expectations are two-way.",
      "Creates a feeling of fairness in the way they establish expectations.",
      "Gets underneath the surface to understand what is really motivating the other person.",
      "Uses failure to deliver or conflict as a cue to revisit expectations.",
    ],
    negativeIndicators: [
      "Dictates expectations or fails to set them.",
      "Deliverables are poorly defined and vague.",
      "Assumes they know what others expect of them.",
      "Only focuses on their own needs or only focuses on the other's needs.",
      "Leaves people feeling that their needs have been pushed aside or ignored.",
      "Only works with people's explicit statements and expectations.",
      "Never revisits expectations.",
    ],
  },
  "Handles conflict": {
    positiveIndicators: [
      "Surfaces disagreement in a non-threatening way.",
      "Approaches difficult issues in an open-minded and creative mindset.",
      "Does not allow conflict to become about good or bad, right or wrong, win or lose.",
      "Gets things to lasting settlements.",
      "Leaves people feeling that they have been treated fairly.",
      "Behaves in ways that minimise defensiveness.",
      "Sustains effectiveness even through intense emotions.",
    ],
    negativeIndicators: [
      "Strays into areas of conflict without noticing until they are there.",
      "Approaches difficult issues in a defensive, opinionated and fixed manner.",
      "Allows ‘splitting': sees conflict in terms of blame, and of good and bad.",
      "Settlements unpick over time.",
      "Leaves people feeling bruised by the conflict and treated unfairly.",
      "Triggers others' defensiveness.",
      "Is disabled by strong emotions.",
    ],
  },
  "Sets direction": {
    positiveIndicators: [
      "Creates an energising sense of purpose.",
      "Describes the future in clear and vivid terms.",
      "Pulls personal and team accountabilities together into an overarching direction.",
      "Sets meaningful goals.",
      "Connects activities into the broader strategy.",
      "Helps others gain a clearer picture of their own role and future.",
    ],
    negativeIndicators: [
      "Focuses only on what needs to be achieved rather than why it is important.",
      "Talks about past performance more than the future.",
      "Unclear how different activities contribute to the whole.",
      "Sets loose or uninspiring targets.",
      "Does not look up and across the organisation.",
      "Focuses on their own contribution rather than their colleagues'.",
    ],
  },
  "Has presence": {
    positiveIndicators: [
      "Uses their voice, gaze and physical self to communicate authority.",
      "Is listened to when they speak.",
      "Others take them and their intentions seriously.",
      "People remember them after they have met.",
      "Knows when to talk and when to stay silent.",
      "Appears at ease with themselves in most situations.",
      "Is prepared to stand out from the crowd.",
    ],
    negativeIndicators: [
      "Has not found their voice, avoids eye contact, appears uncomfortable.",
      "Is talked over or their points are ignored.",
      "Fails to communicate conviction and seriousness of intent.",
      "Leaves unclear impression on others.",
      "Dilutes their impact by talking too little or too much.",
      "Is preoccupied by what others think of them.",
      "Prefers to blend in with the group.",
    ],
  },
  "Engages people": {
    positiveIndicators: [
      "Raises the energy or excitement within a group.",
      "Creates a sense of commitment – to a cause or to them personally.",
      "Communicates in a way that connects with people's energy and desire.",
      "Is seen as a motivational character.",
      "Shows personal passion and engagement.",
      "People put in discretionary effort for them and their cause.",
    ],
    negativeIndicators: [
      "Fails to connect with people's energy and passion.",
      "Leaves people feeling unclear about their commitment levels.",
      "Communicates in a matter-of-fact way.",
      "Rarely manages to raise motivation levels.",
      "Talks about passion but fails to show it.",
      "People do what is expected of them.",
    ],
  },
  "Creates trust": {
    positiveIndicators: [
      "People feel able to talk openly with them.",
      "Relationships are characterised by energy.",
      "Will talk about difficult issues that may be undermining trust.",
      "Is willing to trust others.",
      "Shows patience and commitment within relationships.",
      "Others trust their intentions.",
      "Ensures that others act in ways that build trust.",
    ],
    negativeIndicators: [
      "People are cautious about voicing their true thoughts and feelings to them.",
      "Relationships lack energy.",
      "Avoids difficult issues.",
      "Is cautious or suspicious about whether others can be trusted.",
      "Does not attend to relationships, only to the task at hand.",
      "Seen as self-serving.",
      "Fails to attend to whether others are acting in a trustworthy way.",
    ],
  },
  "Challenges": {
    positiveIndicators: [
      "Constantly looks for opportunities to raise standards.",
      "Holds others to account.",
      "Challenges themselves as much as they challenge others.",
      "Does not allow a need to be liked to prevent them from challenging.",
      "Shows belief in the other person's capacity to improve.",
      "Is rigorous about exploring reasons for poor performance.",
      "Encourages others to challenge themselves.",
    ],
    negativeIndicators: [
      "Happy with established standards.",
      "Inconsistent in holding others to account.",
      "Tough on others but not on themselves.",
      "Allows their need to be liked to prevent them challenging.",
      "Doesn't believe others can improve.",
      "Too easily accepts reasons for poor performance.",
      "Fails to engage others in challenging their own beliefs and standards.",
    ],
  },
  "Enables others": {
    positiveIndicators: [
      "Notices the patterns of strengths and weakness others.",
      "Matches people to assignments that will stretch and develop them.",
      "Coaches people, drawing out their strengths.",
      "Makes others feel that their contribution is valued.",
      "Ensures that people have what they need in order to perform and develop.",
      "Delegates effectively.",
      "Is good at drawing out each person's contribution.",
    ],
    negativeIndicators: [
      "Doesn't tune into people's strengths.",
      "Assigns people to tasks according to what is most straightforward.",
      "Focuses on task delivery rather than on enabling and developing people.",
      "Inhibits people through critical or dismissive comments.",
      "Leaves people to their own devices.",
      "Fails to delegate or remains too hands-on.",
      "Dominates meetings with their own ideas and views.",
    ],
  },
};
